import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-activator',
  templateUrl: './activator.component.html',
  styleUrls: ['./activator.component.scss']
})
export class ActivatorComponent implements OnInit {

  message: string;
  selectedValue: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ActivatorComponent, IActivatorOutput>,
    @Inject(MAT_DIALOG_DATA) public data: IActivatorInput,
  ) { }

  ngOnInit(): void {
    this.message =  this.data.message;
  }

  save(){
    this.dialogRef.close({
      value: this.selectedValue,
      isCanceled: false,
    });
  }

  cancel(){
    this.dialogRef.close({
      isCanceled: true,
    });
  }

}

export interface IActivatorInput {
  message: string,
}

export interface IActivatorOutput {
  value?: boolean,
  isCanceled: boolean
}
